var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkDuotone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.09,
    height: 23.415,
    viewBox: "0 0 30.09 23.415",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "link-duotone",
    transform: "translate(-17.858 -20.881)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17722",
    "data-name": "Path 17722",
    d: "M19.967,107.3a7.2,7.2,0,0,1,0-10.183l5.591-5.637A7.217,7.217,0,0,1,36.508,100.8l-.055.08a1.594,1.594,0,0,1-2.594-1.852l.055-.08a4.015,4.015,0,0,0-6.1-5.173l-5.587,5.592a4.013,4.013,0,0,0,5.168,6.1l.08-.1a1.639,1.639,0,0,1,2.221.413,1.6,1.6,0,0,1-.368,2.226l-.08.055a7.2,7.2,0,0,1-9.276-.767Z",
    transform: "translate(0 -65.115)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17723",
    "data-name": "Path 17723",
    d: "M238.528,22.99a7.2,7.2,0,0,1,0,10.181l-5.592,5.592a7.2,7.2,0,0,1-10.949-9.276l.055-.08a1.594,1.594,0,0,1,2.594,1.852l-.055.08a4.015,4.015,0,0,0,6.1,5.173l5.587-5.592a4.013,4.013,0,0,0-5.168-6.1l-.08.055A1.629,1.629,0,0,1,228.8,24.5a1.591,1.591,0,0,1,.368-2.223l.08-.056a7.2,7.2,0,0,1,9.276.768Z",
    transform: "translate(-192.689)",
    opacity: 0.4
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkDuotone);
export default __webpack_public_path__ + "static/media/link-duotone.6e89132980120528d63c7c32c8b7617c.svg";
export { ForwardRef as ReactComponent };